import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ProductsAPI from '../../api/products';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getProducts(_state) {
    return _state.records;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_PRODUCT_UI_FLAG, { isFetching: true });
    try {
      const response = await ProductsAPI.get();
      commit(types.SET_PRODUCTS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_PRODUCT_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, productObj) => {
    commit(types.SET_PRODUCT_UI_FLAG, { isCreating: true });
    try {
      const response = await ProductsAPI.create(productObj);
      commit(types.ADD_PRODUCT, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PRODUCT_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_PRODUCT_UI_FLAG, { isUpdating: true });
    try {
      const response = await ProductsAPI.update(id, updateObj);
      commit(types.EDIT_PRODUCT, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PRODUCT_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_PRODUCT_UI_FLAG, { isDeleting: true });
    try {
      await ProductsAPI.delete(id);
      commit(types.DELETE_PRODUCT, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PRODUCT_UI_FLAG, { isDeleting: false });
    }
  },
  resetStore({ commit }) {
    commit('RESET_PRODUCTS_STORE');
  },
};

export const mutations = {
  [types.SET_PRODUCT_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  RESET_PRODUCTS_STORE(_state) {
    _state.records = [];
    _state.uiFlags = {
      isFetching: false,
      isCreating: false,
      isUpdating: false,
      isDeleting: false,
    };
  },
  [types.ADD_PRODUCT]: MutationHelpers.create,
  [types.SET_PRODUCTS](_state, data) {
    _state.records = [...data].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
  },
  [types.EDIT_PRODUCT]: MutationHelpers.update,
  [types.DELETE_PRODUCT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
